import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToolTip from "rc-tooltip";
import IntegerInput from '../input/IntegerInput';

const ARFDetail = (props : ARFDetailProps) => {
  const [asnNo, setAsnNo] = useState(props.asnNo);
  const [cases, setCases] = useState(props.cases);

  useEffect(() => {
    setAsnNo(props.asnNo)
  }, [props.asnNo]);

  useEffect(() => {
    setCases(props.cases)
  }, [props.cases]);

  const detailLineChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event?.target.name) {
      case 'asnNo':
        return props.handleChange(event?.target.value ?? '', null, props.index);   
      case 'cases':
        if (!event?.target.value) {
          return props.handleChange(null, 0, props.index);
        } else if(!isNaN(parseInt(event?.target.value))) {
          return props.handleChange(null, parseInt(event?.target.value ?? 0), props.index);
        }
    }
  };

  const removeLine = () => {
    return props.removeLine(props.index);
  }

  const isAsnNoValid = () => {
      return !(((props.index == 0) || (cases > 0)) && !(asnNo || asnNo.trim()));
  }

  const isCasesValid = () => {
    return !(((props.index == 0) || (asnNo || asnNo.trim())) && !cases);
  }


  return <>
    <div>
      <input className={isAsnNoValid() ? '' : 'error'} type="text" value={asnNo} name="asnNo" onChange={detailLineChanged} />
    </div>
    <div className="fieldWithOptions">
      <IntegerInput className={isCasesValid() ? '' : 'error'} type="number" value={cases} name="cases" onChange={detailLineChanged} />
      <ToolTip placement="top" overlay={<span>Add Line</span>}>
        <button
          className="btn btn-orange"
          type="button"
          onClick={props.addLine}
          disabled={ !(isAsnNoValid() && isCasesValid() && (cases > 0)) }>
          +
        </button>
      </ToolTip>
      {props.index > 0 ? <button
        className="btn btn-orange"
        type="button"
        onClick={removeLine}>
        <FontAwesomeIcon icon="trash-alt" title="remove" />
      </button> : ''}
      </div>
    </>
};

export default ARFDetail;

export interface ARFDetailProps {
  cases: number;
  asnNo: string;
  index: number;
  handleChange: (asnNo: string|null, cases: number|null, lineNo: number) => void;
  addLine: () => void;
  removeLine: (index: number) => void;
}
